import { toast } from "react-toastify";

import { BaseAlertTriangleIcon, CrossIcon } from "../../Icons/";
import { Typo } from "../../Typo";

type Props = {
  title?: string;
  description?: string;
};

const ErrorToast = ({
  title,
  description,
  onClose,
}: Props & { onClose?: () => void }) => (
  <div
    className="relative flex w-full items-start gap-2 text-text-negative-bold"
    data-testid="error-toast"
  >
    <BaseAlertTriangleIcon
      aria-hidden="true"
      className="mt-0.5 h-4 w-4 shrink-0"
    />
    <div className="flex flex-1 flex-col gap-2">
      <Typo type="labelSM" textColor="inherit" classes="font-semibold">
        {title}
      </Typo>
      <Typo type="bodySM" textColor="text-[rgba(3,20,46,0.8)]">
        {description}
      </Typo>
    </div>
    <CrossIcon onClick={onClose} className="ml-2 h-4 w-4 text-icon-primary" />
  </div>
);

export function showErrorToast({
  title,
  description,
  containerId,
}: Props & { containerId?: string }) {
  if (!title || !description) return;
  return toast(
    ({ closeToast }) => (
      <ErrorToast
        title={title}
        description={description}
        onClose={closeToast}
      />
    ),
    {
      hideProgressBar: true,
      autoClose: 6000,
      closeButton: false,
      // When several ToastContainers are mounted on one page, scope the toast
      // to a specific container so it doesn't land in an unrelated one.
      containerId,
    },
  );
}
